<div class="loader">
  <p class="update-text">Nueva Versión Disponible</p>
  <button class="btn btn-primary w-100 fw-bold" (click)="reload()">
    Actualizar Ahora
  </button>
</div>
